import React from "react";
import "./About.css";
import pic from "../../assets/about_cover.webp";

import {FaAward} from "react-icons/fa";
import {VscFolderLibrary} from "react-icons/vsc";

const About = ()=>{
    return (
        <section id="about">

            <h5>Get To Know</h5>
            <h2>About Me</h2>

            <div className="container about__container">

                <div className="about__me">
                    <div className="about__me-image">
                        <img src={pic} alt="About Image" />
                    </div>
                </div>

                <div className="about__content">

                    <div className="about__cards">

                        <article className="about__card">
                            <FaAward className="about__icon"/>
                            <h5>Experience</h5>
                            <small>Hands-on Experience</small>
                        </article>

                        <article className="about__card">
                            <VscFolderLibrary className="about__icon"/>
                            <h5>Projects</h5>
                            <small>3+ Completed Projects</small>
                        </article>

                    </div>

                    <p>
                        Innovative and adaptive full-stack developer with a specialization in MERN stack. Enthusiastic in building web apps that solve certain problems for a large number of people. Looking forward to building a respectable future in Web Development.
                    </p>

                    <a href="#contact" className="btn btn-primary" >Don't Be A Stranger</a>
                </div>

            </div>

        </section>
    );
}

export default About;